import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, ShieldCheck, Clock, Zap, CheckCircle2, Sparkles, Crown } from 'lucide-react';
type PlanId = 'standard' | 'elite';
export const BuySection = () => {
  const plans = {
    standard: {
      id: 'standard' as const,
      name: 'Rugby Performance System',
      price: '$19.899',
      oldPrice: '$52.690',
      url: 'https://checkout.ebookpoint.shop/cart/59567227043921:1'
    },
    elite: {
      id: 'elite' as const,
      name: 'Fútbol Explosivo Pro Elite',
      price: '$27.990',
      oldPrice: '$72.490',
      url: 'https://checkout.ebookpoint.shop/cart/59585259831377:1'
    }
  };
  const [selectedPlan, setSelectedPlan] = useState<PlanId>('standard');
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const eliteBonuses = ['Plan de 12 Semanas Por Posición', 'Biblioteca de drills por posición'];
  const extraBonuses = ['Calculadora de proteínas e hidratación', 'Planilla de suplementos basada en evidencia científica actualizada'];
  const activePlan = plans[selectedPlan];
  return <section id="buy-section" className="w-full py-16 px-4 bg-zinc-950 relative overflow-hidden" data-id="element-44">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-lime-500/10 blur-[150px] rounded-full pointer-events-none" data-id="element-45"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-46">
        {/* Extra Bonuses banner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-zinc-900 to-zinc-950 rounded-2xl p-5 border border-lime-500/40 relative overflow-hidden mb-5" data-id="element-47">
          <div className="flex items-center justify-center gap-2 mb-3" data-id="element-48">
            <Sparkles className="w-5 h-5 text-lime-400" data-id="element-49" />
            <h3 className="text-base md:text-xl font-bold uppercase tracking-tight font-oswald text-white text-center" data-id="element-50">
              COMPRANDO HOY LLEVÁ ESTOS{' '}
              <span className="text-lime-400" data-id="element-51">BONOS EXTRA DE REGALO</span>
            </h3>
          </div>

          <div className="grid sm:grid-cols-2 gap-2" data-id="element-52">
            {extraBonuses.map((extra, idx) => <div key={idx} className="bg-zinc-950/80 border border-zinc-800 px-3 py-2 rounded-lg flex items-start gap-2" data-id="element-53">
                <CheckCircle2 className="w-4 h-4 text-lime-500 shrink-0 mt-0.5" data-id="element-54" />
                <p className="font-semibold text-zinc-200 text-xs md:text-sm leading-tight" data-id="element-55">
                  {extra}
                </p>
              </div>)}
          </div>
        </motion.div>

        <div className="bg-zinc-900 border-2 border-lime-500 rounded-3xl p-5 md:p-8 shadow-[0_0_50px_rgba(132,204,22,0.15)]" data-id="element-56">
          <div className="text-center mb-5" data-id="element-57">
            <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-500 px-4 py-2 rounded-full font-bold text-sm mb-4 border border-red-500/20" data-id="element-58">
              <Clock className="w-4 h-4" data-id="element-59" />
              <span data-id="element-60">
                LA OFERTA TERMINA EN: {String(minutes).padStart(2, '0')}:
                {String(seconds).padStart(2, '0')}
              </span>
            </div>

            <h2 className="text-xl md:text-3xl font-bold uppercase tracking-tight mb-1 font-oswald text-white" data-id="element-61">
              ELEGÍ TU <span className="text-lime-400" data-id="element-62">PLAN</span>
            </h2>
            <p className="text-sm text-zinc-400" data-id="element-63">
              Pago único. Acceso de por vida.
            </p>
          </div>

          {/* Plan Selector — two compact cards side by side */}
          <div className="grid md:grid-cols-2 gap-3 mb-6" data-id="element-64">
            {/* STANDARD */}
            <button type="button" onClick={() => setSelectedPlan('standard')} className={`relative text-left rounded-xl p-4 border-2 transition-all ${selectedPlan === 'standard' ? 'border-lime-500 bg-lime-500/5 shadow-[0_0_25px_rgba(132,204,22,0.2)]' : 'border-zinc-800 bg-zinc-950/60 hover:border-zinc-700'}`} data-id="element-65">
              <div className="flex items-start justify-between mb-2" data-id="element-66">
                <div className="flex items-center gap-2" data-id="element-67">
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPlan === 'standard' ? 'border-lime-500 bg-lime-500' : 'border-zinc-600'}`} data-id="element-68">
                    {selectedPlan === 'standard' && <CheckCircle2 className="w-4 h-4 text-zinc-950" data-id="element-69" />}
                  </div>
                  <span className="text-[10px] font-bold uppercase tracking-wider text-zinc-400" data-id="element-70">
                    Plan Standard
                  </span>
                </div>
              </div>

              <h3 className="text-base md:text-lg font-bold font-oswald uppercase leading-tight text-white mb-2" data-id="element-71">
                Rugby Performance System
              </h3>

              <div className="flex items-baseline gap-2 mb-3" data-id="element-72">
                <span className="text-zinc-500 line-through text-sm font-semibold" data-id="element-73">
                  $52.690
                </span>
                <span className="text-lime-400 text-2xl md:text-3xl font-black font-oswald" data-id="element-74">
                  $19.899
                </span>
              </div>

              <ul className="space-y-1" data-id="element-75">
                <li className="flex items-start gap-1.5 text-xs text-zinc-300" data-id="element-76">
                  <CheckCircle2 className="w-3.5 h-3.5 text-lime-500 shrink-0 mt-0.5" data-id="element-77" />
                  <span data-id="element-78">Sistema completo (7 Capítulos)</span>
                </li>
                <li className="flex items-start gap-1.5 text-xs text-zinc-300" data-id="element-79">
                  <CheckCircle2 className="w-3.5 h-3.5 text-lime-500 shrink-0 mt-0.5" data-id="element-80" />
                  <span data-id="element-81">4 Bonos Estratégicos</span>
                </li>
                <li className="flex items-start gap-1.5 text-xs text-zinc-300" data-id="element-82">
                  <CheckCircle2 className="w-3.5 h-3.5 text-lime-500 shrink-0 mt-0.5" data-id="element-83" />
                  <span data-id="element-84">2 Bonos Extra de regalo</span>
                </li>
              </ul>
            </button>

            {/* ELITE */}
            <button type="button" onClick={() => setSelectedPlan('elite')} className={`relative text-left rounded-xl p-4 border-2 transition-all ${selectedPlan === 'elite' ? 'border-amber-400 bg-amber-400/5 shadow-[0_0_25px_rgba(251,191,36,0.2)]' : 'border-zinc-800 bg-zinc-950/60 hover:border-zinc-700'}`} data-id="element-85">
              <div className="absolute -top-2 right-3 bg-amber-400 text-zinc-950 text-[10px] font-black uppercase tracking-wider px-2 py-0.5 rounded" data-id="element-86">
                Más Completo
              </div>

              <div className="flex items-start justify-between mb-2" data-id="element-87">
                <div className="flex items-center gap-2" data-id="element-88">
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPlan === 'elite' ? 'border-amber-400 bg-amber-400' : 'border-zinc-600'}`} data-id="element-89">
                    {selectedPlan === 'elite' && <CheckCircle2 className="w-4 h-4 text-zinc-950" data-id="element-90" />}
                  </div>
                  <span className="text-[10px] font-bold uppercase tracking-wider text-amber-400 flex items-center gap-1" data-id="element-91">
                    <Crown className="w-3 h-3" data-id="element-92" /> Plan Elite
                  </span>
                </div>
              </div>

              <h3 className="text-base md:text-lg font-bold font-oswald uppercase leading-tight text-white mb-2" data-id="element-93">
                Fútbol Explosivo Pro Elite
              </h3>

              <div className="flex items-baseline gap-2 mb-3" data-id="element-94">
                <span className="text-zinc-500 line-through text-sm font-semibold" data-id="element-95">
                  $72.490
                </span>
                <span className="text-amber-400 text-2xl md:text-3xl font-black font-oswald" data-id="element-96">
                  $27.990
                </span>
              </div>

              <ul className="space-y-1" data-id="element-97">
                <li className="flex items-start gap-1.5 text-xs text-zinc-300" data-id="element-98">
                  <CheckCircle2 className="w-3.5 h-3.5 text-amber-400 shrink-0 mt-0.5" data-id="element-99" />
                  <span data-id="element-100">Todo lo del Plan Standard</span>
                </li>
                {eliteBonuses.map((b, i) => <li key={i} className="flex items-start gap-1.5 text-xs text-zinc-200 font-semibold" data-id="element-101">
                    <Crown className="w-3.5 h-3.5 text-amber-400 shrink-0 mt-0.5" data-id="element-102" />
                    <span data-id="element-103">
                      <span className="text-amber-400" data-id="element-104">Bono ELITE:</span> {b}
                    </span>
                  </li>)}
              </ul>
            </button>
          </div>

          {/* Shared Buy Button — URL depends on selected plan */}
          <motion.a key={activePlan.id} href={activePlan.url} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className={`font-black text-lg md:text-2xl py-5 px-6 rounded-2xl uppercase tracking-wider flex items-center justify-center gap-3 transition-all duration-300 w-full max-w-2xl mx-auto font-oswald mb-4 ${selectedPlan === 'elite' ? 'bg-amber-400 hover:bg-amber-300 text-zinc-950 shadow-[0_0_40px_rgba(251,191,36,0.4)]' : 'bg-lime-500 hover:bg-lime-400 text-zinc-950 shadow-[0_0_40px_rgba(132,204,22,0.4)]'}`} data-id="element-105">
            <ShoppingCart className="w-7 h-7" data-id="element-106" />
            COMPRAR {activePlan.price}
          </motion.a>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-zinc-400 font-medium" data-id="element-107">
            <div className="flex items-center gap-2" data-id="element-108">
              <ShieldCheck className="w-5 h-5 text-lime-500" data-id="element-109" />
              <span data-id="element-110">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-111">
              <Zap className="w-5 h-5 text-lime-500" data-id="element-112" />
              <span data-id="element-113">Acceso Inmediato</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};